(function () {
    "use strict";
    /*
        This handles the switching between the Skills and Industries view modes of the FIP Browse template
    */
    const FIP_BROWSE = ".fip-browse";
    const FIP_SKILLS_ACTIVE = "fip-browse--skills-active";
    const FIP_INDUSTRY_ACTIVE = "fip-browse--industry-active";

    const FIP_TOGGLE_SKILLS = ".fip-browse__toggle--skills";
    const FIP_TOGGLE_INDUSTRY = ".fip-browse__toggle--industry";

    const FIP_CONTENT = ".fip-browse__content";
    const FIP_CONTENT_ACTIVE = "fip-browse__content--active";

    const FIP_INDUSTRY_LIST = ".fip-browse-industry__list";
    const FIP_INDUSTRY_ITEM = ".fip-browse-industry__item";

    $(FIP_BROWSE).each((index, fipBrowse) => {
        const browse = $(fipBrowse);
        const fipSkillsToggle = browse.find(FIP_TOGGLE_SKILLS);
        const fipIndustryToggle = browse.find(FIP_TOGGLE_INDUSTRY);
        const fipContent = browse.find(FIP_CONTENT);

        let gridInitalised = false;

        fipSkillsToggle.on("click", () => {
            //Show skills panel
            browse.addClass(FIP_SKILLS_ACTIVE);
            fipContent.removeClass(FIP_CONTENT_ACTIVE);
            $("#" + fipSkillsToggle.attr("aria-controls")).addClass(
                FIP_CONTENT_ACTIVE
            );
            //Hide skills toggle
            fipSkillsToggle.addClass("sr-only");
            fipSkillsToggle.attr("aria-expanded", true);

            //Hide industries panel
            browse.removeClass(FIP_INDUSTRY_ACTIVE);
            //Show industries toggle
            fipIndustryToggle.removeClass("sr-only");
            fipIndustryToggle.attr("aria-expanded", false);
        });

        fipIndustryToggle.on("click", () => {
            //Show industries panel
            browse.addClass(FIP_INDUSTRY_ACTIVE);
            fipContent.removeClass(FIP_CONTENT_ACTIVE);
            const fipIndustryContent = $("#" + fipIndustryToggle.attr("aria-controls"));
            fipIndustryContent.addClass(
                FIP_CONTENT_ACTIVE
            );
            //Hide industries toggle
            fipIndustryToggle.addClass("sr-only");
            fipIndustryToggle.attr("aria-expanded", true);

            //Hide skills panel
            browse.removeClass(FIP_SKILLS_ACTIVE);
            //Show skills toggle
            fipSkillsToggle.removeClass("sr-only");
            fipSkillsToggle.attr("aria-expanded", false);

            if (gridInitalised === false) {
                fipContent.find(FIP_INDUSTRY_LIST).masonry({
                    itemSelector: FIP_INDUSTRY_ITEM,
                });
                gridInitalised = true;
            }
        });
    });
})();

(function () {
    "use strict";
    /*
        This handles the show / hide of the skills 'dialog'
    */

    const FIP_SKILLS = ".fip-browse-skill";

    const FIP_SKILLS_ITEM = ".fip-browse-skill__item";
    const FIP_SKILL_BUTTON = ".fip-browse-skill__button";
    const FIP_SKILL_DIALOG = ".fip-browse-skill-dialog";
    const FIP_SKILL_DIALOG_CLOSE = ".fip-browse-skill-dialog__close";

    const FIP_SKILL_NOT_VISIBLE = "fip-browse-skill--dialog-active";
    const FIP_SKILL_DIALOG_ACTIVE = "fip-browse-skill-dialog--active";

    let dialogInvoker = undefined;

    $(FIP_SKILLS).each((index, fipSkills) => {
        const skills = $(fipSkills);

        skills.find(FIP_SKILLS_ITEM).each((index, fipSkillItem) => {
            const skillItem = $(fipSkillItem);

            const button = skillItem.find(FIP_SKILL_BUTTON);
            const dialog = skillItem.find(FIP_SKILL_DIALOG);
            const dialogClose = skillItem.find(FIP_SKILL_DIALOG_CLOSE);

            button.on("click", (event) => {
                dialogInvoker = event.target;

                skills.addClass(FIP_SKILL_NOT_VISIBLE);
                dialog.addClass(FIP_SKILL_DIALOG_ACTIVE);

                dialogClose[0].focus();
            });

            dialogClose.on("click", () => {
                skills.removeClass(FIP_SKILL_NOT_VISIBLE);
                dialog.removeClass(FIP_SKILL_DIALOG_ACTIVE);

                dialogInvoker.focus();
            });
        });
    });
})();
